module.exports = __webpack_public_path__ + "static/media/bg_lightspot.52f42746.png";